{
  "actionbar.actions": "Darbības",
  "actionbar.actionsAvailable": "Pieejamas darbības.",
  "actionbar.clearSelection": "Notīrīt atlasi",
  "actionbar.selected": "{count, plural, =0 {Nav atlasīts nekas} other {Atlasīts(-i): #}}",
  "actionbar.selectedAll": "Atlasīts viss",
  "button.pending": "gaida",
  "contextualhelp.help": "Palīdzība",
  "contextualhelp.info": "Informācija",
  "dialog.alert": "Brīdinājums",
  "dialog.dismiss": "Nerādīt",
  "dropzone.replaceMessage": "Lai aizstātu, nometiet failu",
  "inlinealert.informative": "Informācija",
  "inlinealert.negative": "Kļūda",
  "inlinealert.notice": "Brīdinājums",
  "inlinealert.positive": "Izdevās",
  "label.(optional)": "(neobligāti)",
  "label.(required)": "(obligāti)",
  "menu.moreActions": "Citas darbības",
  "picker.placeholder": "Izvēlēties…",
  "slider.maximum": "Maksimālā vērtība",
  "slider.minimum": "Minimālā vērtība",
  "table.loading": "Notiek ielāde...",
  "table.loadingMore": "Tiek ielādēts vēl...",
  "table.resizeColumn": "Mainīt kolonnas lielumu",
  "table.sortAscending": "Kārtot augošā secībā",
  "table.sortDescending": "Kārtot dilstošā secībā",
  "tag.actions": "Darbības",
  "tag.hideButtonLabel": "Rādīt mazāk",
  "tag.noTags": "Nav",
  "tag.showAllButtonLabel": "Rādīt visu ({tagCount, number})",
  "breadcrumbs.more": "Vairāk vienumu"
}